// examples
import Home from '@/views/examples/Home';
import ExamplesIndex from '@/views/examples/Index';
import ExampleView from '@/views/examples/Layouts/View';
import AuthenticationPages from '@/views/examples/AuthenticationPages';
import Badge from '@/views/examples/Badge';
import Comments from '@/views/examples/Comments';
import DatePicker from '@/views/examples/DatePicker';
import Files from '@/views/examples/Files';
import Formatting from '@/views/examples/Formatting';
import Alerts from '@/views/examples/Alerts';
import Misc from '@/views/examples/Misc';
import NavigationAndMenus from '@/views/examples/NavigationAndMenus';
import Pagination from '@/views/examples/Pagination';
import Panels1 from '@/views/examples/Panels1';
import Panels2 from '@/views/examples/Panels2';
import PdfExports from '@/views/examples/PdfExports/';
import Product from '@/views/examples/Product';
import ProductSelector from '@/views/examples/ProductSelector';
import RfpTable from '@/views/examples/RfpTable';
import Tabs from '@/views/examples/Tabs';
import Tooltips from '@/views/examples/ToolTips';
import Tooltips2 from '@/views/examples/ToolTips2';
import Typography from '@/views/examples/Typography';
// Forms ("old")
import FormElements from '@/views/examples/Forms/';
// Forms broken down
import FormBuilder from '@/views/examples/Forms/FormBuilder';
import FormList from '@/views/examples/Forms/FormList';
import InlineFormField from '@/views/examples/Forms/InlineFormField';
// Table components
import Stories from '@/views/examples/Tables/Stories';
import TableWithPaginationFilter from '@/views/examples/Tables/WithPaginationFilter';
import TableWithPaginationFiltersRoutes from '@/views/examples/Tables/WithPaginationFilterRoutes';
import TableWithPaginationRoutes from '@/views/examples/Tables/WithPaginationRoutes';
import AppQuoteEditItem from '@/views/examples/AppQuoteEditItem';

export const routes = [
  {
    path: '/',
    name: 'root',
    redirect: { name: 'ExamplesIndex' },
  },
  {
    path: '/examples',
    name: 'ExamplesIndex',
    component: ExamplesIndex,
    redirect: { name: 'Home' },
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home,
      },
      {
        path: 'alerts',
        name: 'Alerts',
        component: Alerts,
        meta: {
          title: 'Alerts',
        },
      },
      {
        path: 'app-alert',
        name: 'AppAlert',
        component: () => import('@/views/examples/AppAlert'),
        meta: {
          title: 'AppAlert',
        },
      },
      {
        path: 'app-button',
        name: 'AppButton',
        component: () => import('@/views/examples/AppButton'),
        meta: {
          title: 'AppButton',
        },
      },
      {
        path: 'app-icon',
        name: 'AppIcon',
        component: () => import('@/views/examples/AppIcon'),
        meta: {
          title: 'AppIcon',
        },
      },
      {
        path: 'comments',
        name: 'Comments',
        component: Comments,
        meta: {
          title: 'Comments',
        },
      },
      {
        path: 'colors',
        name: 'UiV4Colors',
        component: () => import('@/views/examples/UiV4Colors'),
        meta: {
          title: 'UIv4 Colors',
        },
      },
      {
        path: 'app-quote-edit-item',
        name: 'AppQuoteEditItem',
        component: AppQuoteEditItem,
        meta: {
          title: 'AppQuoteEditItem',
        },
      },
      {
        path: 'date-picker',
        name: 'DatePicker',
        component: DatePicker,
        meta: {
          title: 'Date Picker',
        },
      },
      {
        path: 'typography',
        name: 'Typography',
        component: Typography,
        meta: {
          title: 'Typography',
        },
      },
      {
        path: 'formatting',
        name: 'Formatting',
        component: Formatting,
        meta: {
          title: 'Formatting',
        },
      },
      {
        path: 'tooltips',
        name: 'Tooltips',
        component: Tooltips,
        meta: {
          title: 'Tooltips v1',
        },
      },
      {
        path: 'tooltips2',
        name: 'Tooltips2',
        component: Tooltips2,
        meta: {
          title: 'Tooltips v2',
        },
      },
      {
        path: 'panels1*',
        name: 'Panels1',
        component: Panels1,
        meta: {
          title: 'Original Panels',
        },
      },
      {
        path: 'panels2',
        name: 'Panels2',
        component: Panels2,
        meta: {
          title: 'Panels v2',
        },
      },
      {
        path: 'form-elements',
        name: 'FormElements',
        component: FormElements,
        meta: {
          title: 'Form Elements',
        },
      },
      {
        path: 'form-elements-storybook-layout',
        name: 'FormElementsStorybookLayout',
        component: ExampleView,
        redirect: { name: 'FormList' },
        meta: {
          title: 'Form Elements ("storybook" layout)',
        },
        children: [
          {
            component: FormList,
            path: 'form-list',
            name: 'FormList',
            meta: {
              title: 'Form list',
            },
          },
          {
            component: FormBuilder,
            path: 'form-builder',
            name: 'FormBuilder',
            meta: {
              title: 'Form builder',
            },
          },
          {
            component: InlineFormField,
            path: 'inline-form-field',
            name: 'InlineFormField',
            meta: {
              title: 'Inline form field',
            },
          },
        ],
      },
      {
        path: 'tables',
        name: 'Tables',
        component: ExampleView,
        redirect: { name: 'TableStories' },
        meta: {
          title: 'Tables',
        },
        children: [
          {
            component: Stories,
            path: 'stories',
            name: 'TableStories',
            meta: {
              title: 'Stories',
            },
          },
          {
            component: TableWithPaginationRoutes,
            path: 'table-with-pagination-route',
            name: 'TableWithPaginationRoutes',
            meta: {
              routeControls: true,
              title: 'Table with FE pagination (using routes)',
            },
          },
          {
            component: TableWithPaginationFilter,
            path: 'table-with-pagination-filter',
            name: 'TableWithPaginationFilter',
            meta: {
              title: 'Table with FE pagination and filters',
            },
          },
          {
            component: TableWithPaginationFiltersRoutes,
            path: 'table-with-pagination-filter-route',
            name: 'TableWithPaginationFiltersRoutes',
            meta: {
              routeControls: true,
              title: 'Table with FE pagination and filters (using routes)',
            },
          },
        ],
      },
      {
        path: 'navigation-and-menus',
        name: 'NavigationAndMenus',
        component: NavigationAndMenus,
        meta: {
          title: 'Navigation and Menus',
        },
      },
      {
        path: 'tabs',
        name: 'Tabs',
        component: Tabs,
        meta: {
          title: 'Tabs',
        },
      },
      {
        path: 'misc',
        name: 'Misc',
        component: Misc,
        meta: {
          title: 'Miscellaneous',
        },
      },
      {
        path: 'files',
        name: 'Files',
        component: Files,
        meta: {
          title: 'Files',
        },
      },
      {
        path: 'authentication-pages',
        name: 'AuthenticationPages',
        component: AuthenticationPages,
        meta: {
          title: 'Authentication Pages',
        },
        alias: [
          'authentication-pages/landing',
          'authentication-pages/sign-in',
          'authentication-pages/register',
          'authentication-pages/forgot-password',
          'authentication-pages/register/confirmation',
          'authentication-pages/register/confirmation/email',
          'authentication-pages/register/confirm-email',
          'authentication-pages/register/resend-confirmation',
          'authentication-pages/register/reset-password',
          'authentication-pages/terms',
        ],
      },
      {
        path: 'product',
        name: 'Product',
        component: Product,
        meta: {
          title: 'Product',
        },
      },
      {
        path: 'rfp-table',
        name: 'RfpTable',
        component: RfpTable,
        meta: {
          title: 'RFP Table',
        },
      },
      {
        path: 'pdf-exports',
        name: 'PdfExports',
        component: PdfExports,
        meta: {
          title: 'PDF Exports',
        },
      },
      {
        path: 'product-selector',
        name: 'ProductSelector',
        component: ProductSelector,
        meta: {
          title: 'Product Selector',
        },
      },
      {
        path: 'pagination',
        name: 'Pagination',
        component: Pagination,
        meta: {
          title: 'TfPagination',
        },
      },
      {
        path: 'badge',
        name: 'Badge',
        component: Badge,
        meta: { title: 'TfBadge' },
      },
    ],
  },
];

export default routes;
